<div [ngClass]="{'aaa': !isOpenUrl}">

  <div [ngClass]="{'open-tnc-header': isOpenUrl}" class="floating-header">
    <h4>
      TERMS AND CONDITIONS
    </h4>
  </div>
  <div>
    <section [ngClass]="{'tnc-section': !isOpenUrl, 'open-tnc-section': isOpenUrl}" class="dark-bg-info-card"
      id="tnc-main-section" (scroll)="handleTncScroll($event)">
      This document is an electronic record in terms of the Information Technology Act,2000 and applicable rules
      thereunder and the provisions pertaining to electronic records in various applicable statutes. This electronic
      record is generated by a computer system.
      <br />
      This document is published in accordance with the provisions of Rule 3(1) of theInformation Technology
      (Intermediaries Guidelines) Rules, 2011, which requires publishing the rules and regulations, privacy policy and
      terms of use for accessor usage of online Portals.
      <br /> <br />
      ICICI Bank Limited ("ICICI")proposes to facilitate electronic issuance and subscription of commercial paper
      ("Services") offered by entities eligible to issue commercial paper and subscribed by entities eligible to invest
      in commercial papers through an online portal known as ‘CP Online’ (“Portal”) accessible through its website
      {{domainName}}
      and mobile application/mobile site {{domainName}}.

      The Portal has an open architecture which facilitates interaction between distinct user groups and enables
      streamlined communication between such users. The users who are registered on the Portal("User") by ICICI shall be
      entitled to avail the Services. Before registering as a User, you are requested to read these terms and conditions
      ("Terms of Use") carefully. By registering as a User, you accept and agree to be bound by these Terms of Use, as
      amended from time to time and that these Terms of Use have the same force and effect as a signed agreement.


      <h5> USER ELIGIBILITY </h5>

      A User has to be a person who can form legally binding contracts under IndianContract Act, 1872. Persons who are
      not competent to contract as per the provisions of the Indian Contract Act, 1872 including
      minors,un-discharged insolvents etc. are not eligible to use the Portal. ICICI reserves the right to terminate the
      User’s membership and / or refuse to provide the User with access to the Portal if it is brought to ICICI's notice
      or if it is discovered that the User is not competent to contract.

      <h5> YOUR ACCOUNT AND REGISTRATION OBLIGATION </h5>

      i. To access the Portal, a one-time registration process has to be completed by all Users.
      <br />
      ii. The User account will be activated after (a) ICICI verifies the User information in accordance with the Know
      Your Customer guidelines issued by the Reserve Bank of India, from time to time, in such form and manner as may be
      permissible under law; ; (i) the User sets their login credentials with a unique User ID and password; and (ii)
      accepts the Terms of Use.
      <br />
      iii. On the Portal, the identity of each User shall be authenticated by the use of their login credentials. ICICI
      shall at all times treat instructions authenticated by such login credentials to have originated from the User
      directly.
      <br />
      iv. It is the obligation of the User to keep their login credentials confidential and upon any actual or suspected
      unauthorised use of such login credentials, to promptly change the login credentials and inform ICICI of such
      change.
      <br />
      v. The User acknowledges that the User account and the execution of online instructions on the Portal are subject
      to these Terms of Use.

      <br />


      <h5>FEES / CHARGES</h5>
      A subscription/convenience/arrangement fees shall be charged for facilitating the Services. ICICI reserves the
      right to change its fee policy, from time to time. In particular, ICICI may, at its sole discretion, introduce new
      services and/or modify some or all of the existing services offered on the Portal. In such an event, ICICI
      reserves the right to introduce fees for the new services offered or amend/introduce fees for existing services,
      as the case may be. Changes to the fee policy shall be posted on the Portal and such changes shall automatically
      become effective immediately once posted on the Portal. Unless otherwise stated, all fees shall be quoted in
      Indian Rupees.

      <h5>COMMUNICATIONS</h5>
      By using the Portal, the User agrees and understands that communication on the Portal is through electronic means
      and the User consents to receive communications through electronic means. Without prejudice to the aforesaid,
      ICICI may communicate with the User by other modes of communication as well.

      <h5>USE OF THE PORTAL</h5>

      i. The Portal is utilized by the Users to meet and interact with one another for availing the Services and to
      reach a larger base to provide such Services. ICICI, as a Portal provider, would not be a party to, be responsible
      for or control in any manner any transaction between the Portal's Users.
      <br />
      ii. All commercial/contractual terms are offered and agreed between Users alone. ICICI, as a Portal provider, does
      not and shall not be construed to have any control or determine or advise or in any way involve itself in such
      commercial/contractual terms between the Users.
      <br />

      iii. Users are advised to independently verify the bona fides of any particular User that they choose to deal with
      on the Portal and use their own judgment in that behalf.
      <br />

      iv. Users shall independently assess the risks of the transactions undertaken on the Portal. Further, they shall
      independently agree upon the manner and terms and conditions of such service.
      <br />

      v. ICICI is not and shall not be required to mediate or resolve any dispute or disagreement between Users.
      <br />

      vi. ICICI shall not be responsible for the conclusion or non-conclusion of any transaction between Users.
      <br />

      vii. ICICI makes no express or implied warranty in relation to the Services, including:
      <br />

      a) that the dealing through the User account will be uninterrupted or free from errors or that any identified
      defect will be corrected;
      <br />

      b) that the User account service is free from any virus or other malicious, destructive or corrupting code or
      program; and
      <br />

      c) as to quality and performance of the transactions undertaken on the Portal.


      <h5>INSTRUCTIONS</h5>

      Any input, instruction, command or request made by a User in relation to the Services must be correct, complete,
      clear and unambiguous in all respects and should conform to the prescribed procedure/documentation and regulatory
      requirements, failing which, ICICI reserves the right to reject the same and in such a case ICICI shall not be
      responsible for any consequence arising therefrom. ICICI shall not be obliged to accept from the User any oral
      instructions in relation to the Services. If, for any reason such inputs, instructions, commands or requests made
      in relation to the Services by the Users does not get processed, ICICI shall not be responsible for such
      non‐execution of requests.

      <h5>SHARING OF INFORMATION</h5>

      The User agrees to provide any and all information that may be required by ICICI, from time to time, including but
      not limited to contact information, address, tax‐related information and any other information required under
      applicable laws. The User also agrees that ICICI may take steps to verify the veracity of such information
      provided by such User and the User agrees to co‐operate and assist ICICI in verifying such information. The User
      acknowledge that failure to provide such information in a timely manner may result in delay in processing the
      transactions or in the User’s ineligibility to avail some or all of the Services and that ICICI shall in no way be
      held liable for any losses of whatsoever nature resulting from such failure to provide information. The User
      further agrees that the aforesaid information provided to ICICI from time to time, may be shared by ICICI with the
      other Users for facilitating the transaction (on a need to know basis), their respective authorized service
      providers, auditors, legal and tax consultants in compliance with the applicable laws. The User also agrees that
      any information provided may be required to be shared with the relevant regulatory/statutory authorities/third
      party service providers and the User authorise ICICI to provide all information to regulatory / statutory
      authorities/ professional advisors / auditors/ third party service providers, as and when required. The User
      further agrees that such information may also be used by ICICI to:
      <br /> i. contact the User on matters connected with setup and operation of User account;
      <br /> ii. send promotional materials and/or special offers through electronic mail or short message service, in
      compliance with applicable laws provided the User has not opted for the Do Not Disturb Registry with
      ICICI<sup>1</sup>;
      <br /> iii. execute User inputs, instructions, commands and requests in relation to the Services; and
      <br /> iv. transmit to the Users for verification/validation, facilitating the Services and enhancing the User
      experience.

      <div class="mt-2 py-4">
        <sup>1</sup>
        <i>do respect the User’s privacy, and appreciate that the User may not want to receive information from us. If
          this is the case, the User may use the Do Not Mail form available at
          <span class="cp-hyperlink" (click)="navigateToRoute('dnm')" (keydown.enter)="navigateToRoute('dnm')" 
          (keydown.space)="navigateToRoute('dnm')"> {{dnmUrl}}
          </span>for not receiving such information through SMS alerts or e-mails. The details that the User enters in
          the form
          will remain confidential.
        </i>
      </div>

      <h5>GENERAL TERMS</h5>

      i. The User acknowledges that ICICI may, at its sole discretion, withdraw any of the Services provided herein,
      from time to time.
      <br />
      ii. The User may only use the Portal to search for, provide and to apply for Services from time to time and shall
      not use the Portal to make any fraudulent applications. The User agrees not to use the Portal for any purpose that
      is unlawful, illegal or forbidden by these Terms of Use, or applicable laws that might apply to the User. Since
      the Portal is in operation in India, while using the Portal, the User agrees that it shall comply with laws that
      apply to India and the country of the User (in case the User is a foreign national).
      <br />
      iii. ICICI may, at its sole discretion, at any time and without advance notice or liability, suspend, terminate or
      restrict the User’s access to all or any component of the Portal.
      <br />
      iv. The User shall not assign or otherwise transfer rights or obligations under these Terms of Use. ICICI may
      assign its rights and duties under these Terms of Use without any notice to the User.

      <br />
      v. If ICICI fails to act on the User’s breach on any occasion, it shall not be construed as a waiver of right to
      act with respect to future or similar breaches.
      <br />
      vi. The User is prohibited from posting or transmitting to or through this Portal: (i) any unlawful, threatening,
      libellous, defamatory, obscene, pornographic, or other material or content that would violate rights of publicity
      and/or privacy or that would violate any law; (ii) any commercial material or content (including, but not limited
      to, solicitation of funds, advertising, or marketing of any goods or services); and (iii) any material or content
      that infringes, misappropriates or violates any copyright, trademark, patent right or other proprietary right of
      any third party. The User shall be solely liable for any damages resulting from any violation of the foregoing
      restrictions, or any other harm resulting from their posting of content to this Portal.
      <br />

      <h5>CHANGE OF TERMS AND CONDITIONS </h5>

      The User agrees that these Terms of Use may be subject to change/modification for such reason as ICICI may deem
      fit and proper, including but not limited to comply with changes in law, regulation, correct inaccuracies,
      omissions, errors or ambiguities, reflect changes in the process flow, scope and nature of the services, company
      reorganization, market practice or customer requirements. Upon any change, the updated Terms of Use shall be
      updated on the Portal or any other means. The User’s continued use of the Services on the Portal shall be deemed
      as an acceptance of the changes. The User can access the most current version of the Terms of Use at any time on
      the Portal.

      <h5>INDEMNITY</h5>

      The User agrees to indemnify ICICI, its respective officers, directors, employees and agents against any improper/
      fraudulent transactions done or purported to be done by them on the Portal provided by ICICI. Further ICICI, its
      respective officers, employees and agents shall be indemnified for and held free and harmless from and against any
      and all costs, claims, losses or liabilities of any nature (direct or indirect) resulting from such Services,
      together with any and all attendant costs and expenses including reasonable legal fees and expenses, that ICICI,
      its respective officers, employees and agents may incur or be subject to, in relation to the transactions
      undertaken by the User on the Portal.


      <h5>DISCLAIMER OF WARRANTIES AND LIABILITY</h5>

      i. The data, reports, documents and/or information provided on the Portal does not constitute and shall not be
      construed as an advice from ICICI and therefore, should not be relied upon while taking any decisions in relation
      to the Services.
      <br />
      ii. ICICI does not, implicitly or explicitly, support or endorse or solicit entering into any transactions on the
      Portal.
      <br />
      iii. Users acknowledge that they will use their independent judgment and conduct their own due diligence before
      availing any Services or entering into any transactions and ICICI shall not be responsible or liable for any such
      decision taken by the User.
      <br />
      iv. The transaction execution services and the data, reports, documents, information and recommendations, if any,
      are incidental to the Services provided by ICICI and shall not in any manner be construed as offering of any kind
      of investment advisory services or any kind of legal, tax or financial or other advice. The transaction decision,
      if any, will be taken by the User at their sole and absolute discretion. No information regarding any issue
      presented on the Portal shall be construed to fall within the meaning of a “public offer” as contemplated under
      Section 23 read with Section 42 of the Companies Act, 2013.
      <br />
      v. The User also acknowledges that the security and the control provided by ICICI are designed to verify the
      source of the communication and not to detect errors in transmission or content. ICICI shall have no duty to
      verify the content of any transactions, instructions and communication, whether or not authorized, sent in its
      name and accepted by ICICI.
      <br />
      vi. ICICI makes no representation or warranty, whether express or implied, as to the accuracy or completeness of
      any information provided on the Portal and that ICICI assumes no responsibility to provide any updates to, or
      modifications of, such information. The User agrees that any information provided on the Portal does not purport
      to be all-inclusive and may not contain all of the information that would be required to enter into transactions
      on the Portal.
      <br />
      vii. ICICI will be under no duty to verify compliance with any restrictions on the User’s eligibility to transact
      or the creditworthiness, identity, etc. of any of its Users.
      <br />
      viii. ICICI will not be liable for any loss, damage, cost, charges or expenses, directly or indirectly, caused by
      reasons of any defects or imperfections or mechanical or other failure with relation to computer, cable, telex,
      telephone or postal system.


      <h5>PRIVACY</h5>

      We view protection of the User’s privacy as a very important principle. We understand clearly that the User and
      their personal information is one of our most important assets. We store and process the User information
      including any sensitive financial information collected (as defined under the Information Technology Act, 2000),
      if any, on computers that may be protected by physical as well as reasonable technological security measures and
      procedures in accordance with Information Technology Act 2000 and rules there under. Our current privacy policy is
      available at
      <span class="cp-hyperlink" (click)="navigateToRoute('privacy-policy')" (keydown.enter)="navigateToRoute('privacy-policy')" (keydown.space)="navigateToRoute('privacy-policy')"> {{privacyUrl}}
      </span>.
      If you
      object to your information being transferred or used in this way please do not use the Website.


      <h5>LIMITATION OF LIABILITY</h5>

      i. In no event shall ICICI or its authorised representatives or employees or agents be liable for any special,
      incidental, direct, indirect or consequential damages of any kind in connection with the use of the Portal.
      <br />

      ii. Whilst every reasonable precaution has been taken to ensure the accuracy, security and confidentiality of data
      and information available through the User account, ICICI, its authorised representatives or employees or agents
      shall not be held responsible for any consequence of any action carried out by the User.
      <br />

      iii. The Portal and the linked backend infrastructure may be inaccessible and/or unavailable at times. ICICI will
      make every effort to resolve such issues in an expeditious manner. In such an event ICICI, its authorised
      representatives, employees or agents will not be liable for any damage, liability, action, cause of action, suit,
      claim, demand, loss, cost, and expense arising directly or indirectly from or in connection with such system
      inaccessibility and/or unavailability, any consequent delay or failure in completion of any instructions as a
      consequence thereof arising from the use or inability to use the User account.
      <br />

      iv. The User further agrees that ICICI shall not be held liable for any losses, damages, expenses, costs,
      liabilities and claims of whatsoever nature caused by fraudulent or unauthorized use or access of the User
      information, and/or signatures.


      <h5>FORCE MAJEURE</h5>

      Without prejudice to anything mentioned in these Terms of Use, ICICI, its authorised representative, employees or
      agents shall not be held liable for any loss or damage or failure to comply or delay in complying with its
      obligations under these Terms of Use which is caused directly or indirectly by any event or circumstances beyond
      ICICI’s reasonable control. These include system failure, network errors, delay or loss of data due to the above
      and in circumstances of Act of God, floods, epidemics, quarantine, riot, civil commotion and/or war.

      <h5>TRADEMARK, COPYRIGHT AND RESTRICTION</h5>

      The copyrights, trademarks, logos, slogans and service marks displayed on the Portal, are registered and
      unregistered intellectual properties of ICICI or of respective owners of these intellectual properties. Nothing
      contained on the Portal should be construed as granting, by implication, estoppel, or otherwise, any license or
      right to use any intellectual property displayed on the Portal without the written permission of ICICI or such
      third party that may own the intellectual property displayed on the Portal.

      ICICI neither warrants nor represents that the use of materials displayed on the Portal by the User will not
      infringe patent, trademark, copyright or any intellectual property rights or any other rights of third parties not
      owned by or affiliated with ICICI. ICICI grants the right to access the Portal to the User and use the Services in
      accordance with these Terms of Use. The User acknowledges that the Services including, but not limited to, text,
      content, photographs, videos, audios and graphics, are either the properties of, or used with permission by, ICICI
      and/or by the content providers and may be protected by applicable copyrights, trademarks, service marks,
      international treaties and/or other proprietary rights and laws of India and other countries, and the Terms of
      Use. The User should assume that everything it sees or reads on the Portal (including but not limited to
      directories, guides, news articles, opinions, reviews, text, photographs, images, illustrations, profiles, audio
      clips, video clips, trademarks, service marks and the like, collectively "Content") is
      copyrighted/trademarked/protected by intellectual property laws unless otherwise provided and may not be used,
      except as provided in these Terms of Use, without the prior written permission of ICICI or the relevant owners of
      these intellectual properties. The User is also advised that ICICI will aggressively enforce its intellectual
      property rights to the fullest extent of the law, including the seeking of criminal prosecution. Any breach of the
      restrictions on use provided in these Terms of Use is expressly prohibited by law, and may result in severe civil
      and criminal penalties. ICICI shall be entitled to obtain equitable relief (including all damage, direct,
      indirect, consequential and exemplary) over and above all other remedies available to it, to protect its interests
      therein. Notwithstanding anything contained herein, nothing in these Terms of Use shall be deemed to be a
      transfer, license or assignment of any right, title, interest or claim in relation to intellectual property rights
      owned by ICICI or third parties. All rights not expressly granted herein are reserved.


      <h5>TERMINATION</h5>

      ICICI may terminate the Services by giving 30 (thirty) days prior notice which shall be hosted on the Portal.
      However, the User shall not be relieved of obligations incurred prior to such termination.

      <h5>GOVERNING LAW</h5>
      These Terms and Condition shall be governed by, and construed in accordance with the laws of India. Any dispute,
      controversy or claims arising out of or relating to the Services or the breach, termination or invalidity of these
      Terms of Use shall be referred to the exclusive jurisdiction of courts located in Mumbai, India.

      <h5>CONTACT US</h5>

      Please <span class="cp-hyperlink" (click)="navigateToRoute('contact-us')" (keydown.enter)="navigateToRoute('contact-us')" (keydown.space)="navigateToRoute('contact-us')"> contact us
      </span>. for any questions or comments regarding this Portal.


    </section>
  </div>
</div>
